import React from "react";
import { useSelector } from "react-redux";
import SectionItem from "../../../../components/section/section-item/SectionItem";
import AppointmentTypesAccordion from "./appointment-types-accordion/AppointmentTypesAccordion";

const AppointmentTypesSection = () => {
  const { updatedCalendarInfo } = useSelector((state) => state.calendarManagement);

  if (!updatedCalendarInfo?.id) {
    return null;
  }

  return (
    <SectionItem
      title="Appointment types"
      subtitle="Define the service appointments you'd like the Smart Receptionist to offer to your customers."
      content={<AppointmentTypesAccordion />}
    />
  );
};

export default AppointmentTypesSection;
